import { TabGroup } from 'procyon-ui'
import React from 'react'
import { OverviewTab } from './OverviewTab'
import { AccessGraph } from './AccessGraph'
import { AccessSummary } from './AccessSummary'

const Tabs = () => {
  return (
    <div className='mt-2 p-4 bg-[var(--color-common-bg-base)]'>
      <TabGroup
        tabs={[
          {
            label: 'Overview',
            tabContent: <OverviewTab />
          },
          {
            label: 'Access Summary',
            tabContent: <AccessSummary />
          },
          {
            label: 'Access Graph',
            tabContent: <AccessGraph />
          }
        ]}
      />
    </div>
  )
}

export { Tabs }
